const LoadingShow = (text,colNum) => {
    return `<td colspan="${colNum}" class="text-center"> ${text}</td>`
}

export default LoadingShow